/**
 * 遅れのバッジ。**段階で色を変える。**
 *
 * 分数だけだと 5 分と 35 分が同じ重さに見える。読まなくても荒れている便が
 * 分かるように、青緑（早発）→緑（定刻）→黄→橙→赤→ピンク→紫と移す。
 *
 * **「運行中」は遅れの段に載せない。**西鉄が遅れを返さない便
 * （大幅遅延で身元ごと落ちた便。OPERATION_ANALYSIS_PLAN.md §10）がこれで、
 * **遅れが小さいのではなく分かっていない。**段に混ぜると「軽い」と読まれる
 * ので、色相のどこにも属さない濃い灰にする。
 */

/** 上限（分）と CSS のクラス。**上から順に見る** */
const STEPS = [
  [2, "d-2"],     // 〜2分
  [5, "d-5"],     // 〜5分
  [10, "d-10"],   // 〜10分
  [15, "d-15"],   // 〜15分
  [20, "d-20"],   // 〜20分
  [30, "d-30"],   // 〜30分
  [45, "d-45"],   // 〜45分
  [59, "d-59"],   // 〜59分
];

/**
 * @param {number|null} minutes 遅れ（分）。null は「分かっていない」
 * @returns {{cls: string, text: string, label: string}}
 */
export function delayBadge(minutes) {
  if (minutes === null || minutes === undefined) {
    return { cls: "d-unknown", text: "運行中", label: "運行中 - 遅れ時分不明" };
  }
  if (minutes < 0) {
    return { cls: "d-early", text: `${minutes}`, label: `${-minutes}分早発` };
  }
  if (minutes === 0) {
    return { cls: "d-ontime", text: "定刻", label: "定刻" };
  }

  const step = STEPS.find(([max]) => minutes <= max);
  // 1 時間以上。**段の外に出さずに、いちばん濃いところで止める**
  const cls = step ? step[1] : "d-60";

  return { cls, text: `+${minutes}`, label: `${minutes}分遅れ` };
}
